import React from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { ItemLine } from "./ItemLine";
import { FormatedPrice } from "./FormatedPrice";
import { SubItem } from "./SubItem";
import { OtherExpenses } from "./OtherExpenses";
import { Money } from "@Shared/Components/Money/Money";
import { useServiceProvider } from "@modules/ServiceProviders/hooks/useServiceProvider";

export const ServiceOfferItem = ({
  preview,
  priceCents,
  currency,
  billingUnit,
  billingCount,
  expenses,
  totalExpenses,
  serviceProviderId,
}) => {
  const { serviceProvider } = useServiceProvider(serviceProviderId, {
    includes: ["user"],
  });

  const serviceProviderName = serviceProvider?.user?.firstName;
  return (
    <>
      <ItemLine
        title={
          <FormattedMessage
            {...messages.spOffer}
            values={{ serviceProviderName }}
          />
        }
        style={{ borderTopWidth: 0 }}
      >
        <SubItem
          title={<FormattedMessage {...messages[billingUnit]} />}
          price={
            <FormatedPrice
              preview={preview}
              priceCents={priceCents * billingCount}
              currency={currency}
              billingUnit={billingUnit}
              billingCount={billingCount}
              rateAmount={priceCents / 100}
            />
          }
        />
        <>
          {expenses.length > 0 && (
            <SubItem
              title={<FormattedMessage {...messages["otherExpenses"]} />}
              price={<Money cents={totalExpenses} currency={currency} />}
            >
              <OtherExpenses linkedExpenses={expenses} />
            </SubItem>
          )}
        </>
      </ItemLine>
    </>
  );
};
